// start:ng42.barrel
export * from './acopio-autocomplete';
export * from './categoria-autocomplete';
export * from './colaborador-autocomplete';
export * from './cuenta-autocomplete';
export * from './etiqueta-autocomplete';
export * from './cuentaetiqueta-autocomplete';
export * from './motor-autocomplete';
export * from './roles-autocomplete';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/index.ts